import { apiClient } from "./ApiClient";

// Batch endpoints
export const createBatchForBlendVersionApi = (blendId, versionId, batch) =>
  apiClient.post(`/api/blends/${blendId}/versions/${versionId}/batches`, batch);

// List active batches for a given blend version
export const retrieveBatchesByBlendVersionApi = (blendId, versionId) =>
  apiClient.get(`/api/blends/${blendId}/versions/${versionId}/batches`);

// Get a single batch
export const retrieveBatchByIdApi = (blendId, versionId, batchId) =>
  apiClient.get(`/api/blends/${blendId}/versions/${versionId}/batches/${batchId}`);

// Update a batch
export const updateBatchApi = (blendId, versionId, batchId, batch) =>
  apiClient.put(`/api/blends/${blendId}/versions/${versionId}/batches/${batchId}`, batch);

// Delete a batch
export const deleteBatchApi = (blendId, versionId, batchId) =>
  apiClient.delete(`/api/blends/${blendId}/versions/${versionId}/batches/${batchId}`);

// Cost components for a batch
export const retrieveBatchCostComponentsApi = (batchId) =>
  apiClient.get(`/api/batches/${batchId}/components`);

export const createAddBackBatchApi = (
  { shippingInstructionId, quantityToShip },
  batch
) =>
  apiClient.post(`/api/batches/add-back`, batch, {
    params: { shippingInstructionId, quantityToShip },
  });

export const allocateBatchToShippingInstructionApi = (
  blendId,
  versionId,
  batchId,
  { shippingInstructionId, quantityToShip, unitPriceEur, allocationCurrency, allocatedUnitPriceOriginal, allocatedFxRateToEur }
) =>
  apiClient.post(
    `/api/blends/${blendId}/versions/${versionId}/batches/${batchId}/allocate`,
    null,
    {
      params: {
        shippingInstructionId,
        quantityToShip,
        unitPriceEur,
        allocationCurrency,
        allocatedUnitPriceOriginal,
        allocatedFxRateToEur,
      },
    }
  );
